type SharedAdvertisingEvent =
  | 'AddPaymentInfo'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'CompleteRegistration'
  | 'Contact'
  | 'CustomizeProduct'
  | 'Donate'
  | 'FindLocation'
  | 'InitiateCheckout'
  | 'Lead'
  | 'PageView'
  | 'Purchase'
  | 'Schedule'
  | 'Search'
  | 'StartTrial'
  | 'SubmitApplication'
  | 'Subscribe'
  | 'ViewContent';

type GTMEventData = {
  [key: string]: unknown;
  event: string;
};

// Extend the Window interface safely
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    dataLayer?: GTMEventData[];
  }
}

export const gtmEvent = (event: string, data: Record<string, unknown> = {}): void => {
  if (typeof window === 'undefined') return; // SSR safety

  if (!window.dataLayer) {
    return;
  }
  // eslint-disable-next-line fp/no-mutating-methods
  window.dataLayer.push({
    event,
    ...data,
  });
};

export const useAdvertisingHook = () => {
  const trackAdvertising = (event: SharedAdvertisingEvent, data?: Record<string, unknown>) => {
    trackGoogleTagManger(event, data);
  };

  const trackGoogleTagManger = (event: string, data?: Record<string, unknown>) => {
    gtmEvent(event, data);
  };

  return {
    trackAdvertising,
  };
};
export type TypedAdvertisingTrack = ReturnType<typeof useAdvertisingHook>['trackAdvertising'];
